<template>
  <div class="p-3">
    <div v-if="isLoading">
      <OtherLoading />
    </div>
    <!-- {{ ticketDetail }} -->
    <div class="text-normal" v-else>
      <b-row class="no-gutters mt-3" style="column-gap: 15px">
        <b-col class="order-2 order-md-1"
          ><div class="left-panel">
            <TicketDetail
              @forwardDetail="forwardDetail"
              :ticketDetail="ticketDetail"
              :form="formDetail.form_field"
            />

            <ActivityList
              ref="activityList"
              :ticketDetail="ticketDetail"
              :ticketId="ticketId"
              :isShowActivity="isShowActivity"
              :userProfile="userProfile"
              :pluginEmail="formDetail.pluginEmail"
              @getDetail="getFormDetail"
              :setting="setting"
            /></div
        ></b-col>
        <b-col sm="4" class="ml-2"
          ><div class="right-panel">
            <div>
              <TicketCustomerDetail
                v-if="userProfile"
                :profile="userProfile"
                :ticketDetail="ticketDetail"
              />
            </div>
            <div class="activity-form" v-if="formDetail.form_field.length">
              <div class="form">
                <FormInputList
                  :items="formDetail.form_field || []"
                  :status="formDetail.ticket.ticket_status_id || 0"
                  :depth="0"
                  :errors="$v.formDetail.form_field"
                  :is-edit="true"
                  :currentPage="currentPage"
                  :rawAdmin="ticketDetail.ticket.assign_to"
                  :isDeleted="ticketDetail.ticket.deleted"
                />
              </div>
              <div class="pagination-wrapper" v-if="hasPage">
                <div>{{ currentPage }} / {{ totalPage }}</div>
                <div class="pagination-action">
                  <b-button
                    class="btn main-color btn-save w-100px"
                    :disabled="currentPage == 1"
                    @click="prevPage"
                  >
                    Previous</b-button
                  >

                  <b-button
                    class="btn main-color btn-save w-100px"
                    :disabled="currentPage == totalPage"
                    @click="nextPage"
                  >
                    Next</b-button
                  >
                </div>
              </div>
              <div class="action py-2">
                <b-button
                  class="main-color btn-save"
                  @click="sendForm"
                  :disabled="ticketDetail.ticket.deleted == 1"
                >
                  Update
                </b-button>
              </div>
            </div>
          </div></b-col
        ><b-col sm="4" class="d-block d-md-none">
          <div class="mb-2 text-bold" @click="visible = !visible">
            Customer Detail
            <font-awesome-icon
              :icon="visible ? 'chevron-up' : 'chevron-down'"
              class="ml-2"
            />
          </div>
          <b-collapse
            id="accordion-1"
            accordion="my-accordion"
            role="tabpanel"
            v-model="visible"
          >
            <div class="right-panel">
              <div>
                <TicketCustomerDetail
                  v-if="userProfile"
                  :profile="userProfile"
                />
              </div>
              <div class="activity-form" v-if="formDetail.form_field.length">
                <div class="form">
                  <FormInputList
                    :items="formDetail.form_field || []"
                    :status="formDetail.ticket.ticket_status_id || 0"
                    :depth="0"
                    :errors="$v.formDetail.form_field"
                    :is-edit="true"
                    :currentPage="currentPage"
                    :rawAdmin="ticketDetail.ticket.assign_to"
                  />
                </div>
                <div class="pagination-wrapper" v-if="hasPage">
                  <div>{{ currentPage }} / {{ totalPage }}</div>
                  <div class="pagination-action">
                    <b-button
                      class="btn main-color btn-save w-100px"
                      :disabled="currentPage == 1"
                      @click="prevPage"
                    >
                      Previous</b-button
                    >

                    <b-button
                      class="btn main-color btn-save w-100px"
                      :disabled="currentPage == totalPage"
                      @click="nextPage"
                    >
                      Next</b-button
                    >
                  </div>
                </div>
                <div class="action py-2">
                  <b-button
                    variant="custom-primary"
                    class="main-color btn-save"
                    @click="sendForm"
                  >
                    Update
                  </b-button>
                </div>
                <hr />
              </div>
            </div>
          </b-collapse>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import ModalCustomerList from "@/components/ticket/activity/ModalCustomerList";
// import SidebarThread from "@/components/ticket/activity/thread/sidebar";
import FormInputList from "@/components/FormInputList";
import RecentActivity from "@/components/ticket/activity/RecentActivity";
import { requiredIf } from "vuelidate/lib/validators";
import TicketCustomerDetail from "@/components/ticket/activity/TicketCustomerDetail";
import TicketDetail from "@/components/ticket/activity/TicketDetail";
import ActivityList from "@/components/ticket/activity/ActivityList";
import OtherLoading from "@/components/loading/OtherLoading";
// import CreateNewUser from "@/components/SideBarCreateCustomer/CreateNewUser";

export default {
  components: {
    // SidebarThread,
    FormInputList,
    RecentActivity,
    TicketCustomerDetail,
    TicketDetail,
    ActivityList,
    OtherLoading,
    // CreateNewUser,
    ModalCustomerList,
  },
  data() {
    return {
      isShowActivity: false,
      isLoading: true,
      isSubmit: false,
      ticketId: 0,
      formActionType: "submit",
      currentPage: 1,
      formDetail: {
        ticket_answer: [],
        form_field: [],
        ticket: {
          activity_source_id: 0,
          assign_to: "",
          created_by: "",
          created_time: "",
          id: 0,
          name: "",
          sla_status: 0,
          ticket_detail: "",
          ticket_form_id: 0,
          ticket_status_id: 0,
          ticket_type_id: 0,
          updated_by: "",
          updated_time: "",
          user_guid: "",
        },
        user_detail: {
          user_guid: null,
          name: null,
          member_id: null,
          telephone: null,
          email: null,
          member_tier: null,
          register_date: "0001-01-01T00:00:00",
          consent_status: null,
          is_connect: 0,
          is_company: 0,
          picture: null,
        },
      },
      selectedCustomer: null,
      ticketDetail: {
        ticket_answer: [],
        form_field: [],
        ticket: {
          activity_source_id: 0,
          assign_to: "",
          created_by: "",
          created_time: "",
          id: 0,
          name: "",
          sla_status: 0,
          ticket_detail: "",
          ticket_form_id: 0,
          ticket_status_id: 0,
          ticket_type_id: 0,
          updated_by: "",
          updated_time: "",
          user_guid: "",
        },
        user_detail: {
          user_guid: null,
          name: null,
          member_id: null,
          telephone: null,
          email: null,
          member_tier: null,
          register_date: "0001-01-01T00:00:00",
          consent_status: null,
          is_connect: 0,
          is_company: 0,
          picture: null,
        },
        setting: {},
        visible: false,
      },
    };
  },
  computed: {
    userProfile() {
      return this.ticketDetail.form_field.find((el) => el.ticket_field_id == 1)
        ?.selectedValue;
    },
    formStatus() {
      return this.formDetail.form_field.find((el) => el.ticket_field_id == 5)
        .value;
    },
    hasPage() {
      return this.formDetail.form_field.some((el) => el.field_type_id == 14);
    },
    totalPage() {
      return this.formDetail.form_field[this.formDetail.form_field.length - 1]
        .page;
    },
  },

  validations() {
    return {
      formDetail: {
        form_field: {
          $each: {
            value: {
              required: requiredIf(function (item) {
                const isSubmit =
                  this.formActionType === "submit" &&
                  Boolean(item.is_require_submit);
                const isClose =
                  (this.formActionType === "close" || this.formStatus == 4) &&
                  Boolean(item.is_require_close);
                return isSubmit || isClose;
              }),
            },
            field_dependent: {
              $each: {
                value: {
                  required: requiredIf(function (item) {
                    const isSubmit =
                      this.formActionType === "submit" &&
                      Boolean(item.is_require_submit) &&
                      item.isActive;
                    const isClose =
                      (this.formActionType === "close" ||
                        this.formStatus == 4) &&
                      Boolean(item.is_require_close) &&
                      item.isActive;
                    return isSubmit || isClose;
                  }),
                },
                field_dependent: {
                  $each: {
                    value: {
                      required: requiredIf(function (item) {
                        const isSubmit =
                          this.formActionType === "submit" &&
                          Boolean(item.is_require_submit) &&
                          item.isActive;
                        const isClose =
                          (this.formActionType === "close" ||
                            this.formStatus == 4) &&
                          Boolean(item.is_require_close) &&
                          item.isActive;
                        return isSubmit || isClose;
                      }),
                    },
                  },
                },
              },
            },
          },
        },
      },
    };
  },
  async created() {
    this.ticketId = this.$route.params.ticketId;
    if (this.ticketId) this.getFormDetail();
  },
  methods: {
    nextPage() {
      this.currentPage += 1;
      this.$forceUpdate();
    },
    prevPage() {
      this.currentPage -= 1;
      this.$forceUpdate();
    },
    async getFormDetail() {
      this.isLoading = true;
      // const res = await this.axios("ticket/setting");
      // console.log(res.data);
      // this.setting = res.data.detail;
      const { data } = await this.axios(`/ticket/${this.ticketId}`);
      if (data.result === 1 && data.detail.form_field.length) {
        data.detail.form_field.forEach((element) => {
          element.field_dependent = this.mapFieldFromDepth(
            element.field_dependent,
            element.id
          );
        });
        this.formDetail = data.detail;
        this.formDetail.form_field = await this.mappingValue(
          data.detail.form_field
        );
        this.ticketDetail = { ...JSON.parse(JSON.stringify(this.formDetail)) };
      }
      this.isLoading = false;
    },
    mapFieldFromDepth(fields, parentId = null) {
      if (!fields?.length) return [];
      return fields
        .filter((el) => el.parent_id === parentId)
        .map((el) => {
          return {
            ...el,
            field_dependent: this.mapFieldFromDepth(
              fields,
              el.ticket_form_field_id
            ),
          };
        });
    },

    async mappingValue(items, page = 1) {
      if (!items.length) return;
      const promises = items.map(async (el, index) => {
        if (items[index - 1] && items[index - 1].field_type_id == 14) {
          page = await (page + 1);
        }

        if (el.field_dependent?.length) {
          el.field_dependent = await this.mappingValue(
            el.field_dependent,
            page
          );
        }

        const target = await this.formDetail.ticket_answer.find(
          (ans) =>
            ans.ticket_form_field_id === (el.ticket_form_field_id || el.id)
        );

        let value = target?.value;
        let displayValue = "";
        let selectedValue = null;
        let rawValue = el.value;

        if (el.ticket_field_id === 7 && value) {
          const admin = await this.getAdminDetail(value);
          if (admin) {
            displayValue = admin.displayValue;
            selectedValue = {
              ...admin.selectedValue,
            };
          }
        } else if (el.ticket_field_id === 1 && value) {
          const customer = this.formDetail.user_detail;
          if (customer) {
            displayValue = [customer?.name, customer?.telephone]
              .filter((el) => el)
              .join(", ");

            selectedValue = {
              ...this.formDetail.user_detail,
            };
          }
        } else if (el.field_type_id === 2) {
          value = value ? value.split(",") : [];
        } else if (el.field_type_id === 3 && value) {
          let defaultValue = value.split(",");
          value = el.field_choice.filter((el) =>
            defaultValue.includes(el.id.toString())
          );
        } else if (el.ticket_field_id === 6 && value) {
          let defaultValue = value.split(",");
          value = el.field_choice.find((el) =>
            defaultValue.includes(el.id.toString())
          );
        } else if (el.name === "RelatedTicket") {
          value = this.formDetail.ticket_relate_list;
        }

        return {
          ...el,
          value: value || null,
          displayValue,
          selectedValue,
          answerId: target?.id || 0,
          isActive: false,
          page: page,
          rawValue: rawValue,
          name: el.name,
        };
      });

      const allResults = await Promise.all(promises);
      return allResults;
    },

    flatFields(data) {
      return data
        .reduce((acc, x) => {
          acc = acc.concat(x);
          if (x.field_dependent) {
            acc = acc.concat(this.flatFields(x.field_dependent));
            x.field_dependent = [];
          }
          return acc;
        }, [])
        .map((el) => {
          let value = el.value;
          let rawValue = el.value;

          if (el.field_type_id == 2)
            value = el.value?.map((item) => item).join(",");
          else if (el.field_type_id == 3)
            value = el.value?.map((item) => item.id).join(",");
          else if (el.ticket_field_id == 6) value = el.value ? el.value.id : "";
          else if (el.name == "RelatedTicket") {
            value = el.value
              .map((item) => item.ticket_relate_type_id)
              .join(",");
          }
          return {
            id: el.answerId || 0,
            ticket_form_field_id: el.ticket_form_field_id || el.id,
            ticket_field_id: el.ticket_field_id,
            value: value ? value.toString() : "",
            is_default_field: el.is_default_field,
            field_dependent: el.field_dependent?.length
              ? this.flatFields(el.field_dependent)
              : [],
            rawValue: rawValue ? value.toString() : "",
            name: el.name,
          };
        });
    },

    async sendForm(bypass = false, action_anonymous = 0) {
      this.formActionType = "submit";
      if (!bypass) {
        this.$v.formDetail.$touch();
        if (this.$v.formDetail.$error) {
          return;
        }
      }
      this.$bus.$emit("showLoading");

      const field_answer = this.flatFields(
        JSON.parse(JSON.stringify(this.formDetail.form_field))
      );

      const ticket = field_answer.find(
        (answer) => answer.name == "RelatedTicket"
      );
      const relatedTicketValue = ticket
        ? ticket.rawValue.map((answer) => {
            return {
              id: answer.id,
              ticket_relate_type_id: answer.ticket_relate_type_id,
              ticket_relate_ref_id: answer.ticket_relate_ref_id,
            };
          })
        : [];
      const payload = {
        id: this.ticketId,
        ticket_form_id: 1,
        action_anonymous: action_anonymous,
        email: this.$route.query.email || "",
        field_answer: this.flatFields(
          JSON.parse(JSON.stringify(this.formDetail.form_field))
        ),
        ticket_relate_list: relatedTicketValue,
      };

      const { data } = await this.axios.post(`/ticket`, payload);

      this.$bus.$emit("hideLoading");
      if (data.result == 1) {
        this.isLoading = false;

        this.successAlert().then(() => {
          this.getFormDetail();
        });
      } else {
        this.isLoading = false;
        this.errorAlert(data.message);
      }
    },

    async getBranchList(field, id) {
      await this.$store.dispatch("getBranch", parseInt(id));
      field.branchList = this.$store.state.coupon.branchList.detail;
      this.branchList = this.$store.state.coupon.branchList.detail;
    },

    async getCustomerDetail(id) {
      const payload = {
        search: "",
        page: 1,
        pageSize: 1,
        user_guid: id,
      };
      const { data } = await this.axios.post(
        `/ticket/filter/customer`,
        payload
      );
      if (data?.detail?.data) {
        const admin = data.detail.data[0];
        return {
          selectedValue: {
            ...admin,
          },
          displayValue: [admin?.name, admin?.telephone]
            .filter((el) => el)
            .join(", "),
        };
      }
      return null;
    },

    async getAdminDetail(id) {
      const payload = {
        search: "",
        page: 1,
        pageSize: 1,
        user_guid: id,
      };
      const { data } = await this.axios.post(`/ticket/filter/admin`, payload);
      if (data?.detail?.data) {
        const admin = data.detail.data[0];
        return {
          selectedValue: {
            ...admin,
          },
          displayValue: [admin?.name, admin?.telephone]
            .filter((el) => el)
            .join(", "),
        };
      }
      return null;
    },

    async updateActivityByAction(actionType) {
      this.formActionType = actionType == 2 ? "close" : "delete";
      if (actionType == 2) {
        this.$v.formDetail.$touch();
        if (this.$v.formDetail.$error) {
          return;
        }
      }

      this.$bus.$emit("showLoading");
      const tickets = [
        {
          ticket_id: this.ticketId,
          ticket_form_id: 1,
        },
      ];
      const payload = {
        tickets: tickets,
        assignTo: "",
        action_type: actionType, // 1 = assign to , 2 = delete
      };

      const { data } = await this.axios.post(`/ticket/action`, payload);

      this.$bus.$emit("hideLoading");
      if (data.result == 1) {
        this.successAlert().then(() => {
          if (actionType == 3) this.$router.push("/ticket-activity");
          else this.getFormDetail();
        });
      } else {
        this.errorAlert(data.message);
      }
    },
    onClickCreateUser() {
      this.$refs.newUser.createUser(this.ticketDetail.customer_email);
    },
    handleSelectedCustomer(customer) {
      let message = `Do you want to move this ticket to a customer ${customer.name} ?`;
      this.confirmAlert({ message: message }).then((val) => {
        if (val.isConfirmed) {
          let index = this.formDetail.form_field.findIndex(
            (el) => el.ticket_field_id == 1
          );

          this.formDetail.form_field[index].value = customer.user_guid;
          this.sendForm(true);
        } else {
          // alert("no");
        }
      });
    },
    handleCustomer() {
      this.$refs.customerModal.show();
    },
    async onFinish(user_guid) {
      if (!user_guid) return;
      // console.log(user_guid, "main");
      let index = await this.formDetail.form_field.findIndex(
        (el) => el.ticket_field_id == 1
      );

      this.formDetail.form_field[index].value = user_guid;
      this.sendForm(true, 1);
    },
    openViewDetail(items) {
      this.$refs.viewDetailThread.show(items);
    },
    async viewAllThread() {
      await this.$nextTick();
      this.$refs.thread.show(1);
    },
    forwardDetail() {
      this.$refs.activityList.$refs.sidebarForward.show({
        ...this.ticketDetail.ticket,
        attach_file: this.ticketDetail.attach_file,
        note: this.ticketDetail.ticket.ticket_detail,
        id: this.ticketDetail.ticket_activity_id,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .text-float-normal .input-custom {
  label {
    color: #5b5b5b;
    font-size: 16px;
    font-weight: 100;
  }
}

.activity-form {
  background-color: white;
  padding: 16px;
  position: relative;
  border-radius: 0.75rem;

  .btn-save {
    width: 100%;
  }
}

.btn-save {
  width: auto;
}

#footer {
  position: fixed;
  bottom: 0;
  left: 256px;
  right: 0;
  height: 10%;
  padding: 15px;
  background: #fff;
}

.badge-new {
  background-color: rgb(39, 189, 167);
  color: white;
  padding: 0.4em 0.6em;
}

::v-deep .header-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
}

::v-deep .header-tablepage {
  margin: 0 !important;
}

.pagination-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .pagination-action {
    display: flex;
    gap: 8px;
    align-items: center;
  }
}

.w-100px {
  width: 101px !important;
  min-width: 0 !important;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
